module.exports = __webpack_public_path__ + "img/bus-partner-img3.6c78e6e9.png";